import { render } from "./UiDropdown.vue?vue&type=template&id=115fd553&ts=true"
import script from "./UiDropdown.vue?vue&type=script&lang=ts"
export * from "./UiDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__